export const ACTION_LOGIN = 'ACTION_LOGIN';

export function login() {
    const test_user = {
        username: 'test_user',
        password: 'sdgsdgsdgsn4n2on6o24n'
    };

    return {type: ACTION_LOGIN, payload: JSON.stringify(test_user)}
}